import { radius } from './tokens';

export const PUBLIC_CHROME_SHELL_CLASS = [
  'inline-flex items-center gap-2',
  radius.md,
  'border border-orange-200/70 bg-white/90 px-2 py-1.5 shadow-soft backdrop-blur-md',
  ' ',
].join(' ');

export const PUBLIC_CHROME_SHELL_COMPACT_CLASS = [
  'inline-flex h-8 items-center',
  radius.sm,
  'border border-orange-200/70 bg-white/90 p-0.5 shadow-soft backdrop-blur-md',
  '  xl:h-11',
].join(' ');

export const PUBLIC_CHROME_FIXED_LEFT_CLASS =
  'fixed top-[max(1rem,env(safe-area-inset-top))] left-[max(1rem,env(safe-area-inset-left))] z-[100] shrink-0';

export const PUBLIC_CHROME_FIXED_RIGHT_CLASS =
  'fixed top-[max(1rem,env(safe-area-inset-top))] right-[max(1rem,env(safe-area-inset-right))] z-[100] shrink-0';

export const PUBLIC_CHROME_TOGGLE_CLASS =
  `inline-flex ${radius.sm} bg-secondary-100/80 p-0.5 `;

export const PUBLIC_CHROME_TOGGLE_COMPACT_CLASS =
  'inline-flex h-full items-stretch rounded-lg bg-secondary-100/80 p-0.5 ';

export const PUBLIC_CHROME_INNER_BUTTON_CLASS =
  'inline-flex items-center rounded-lg px-2.5 py-1 text-xs font-bold leading-none tracking-wide transition-colors whitespace-nowrap text-secondary-600 group-hover:text-orange-600  ';

export const PUBLIC_CHROME_INNER_BUTTON_COMPACT_CLASS =
  'inline-flex h-full items-center justify-center gap-1.5 rounded-md px-2.5 text-xs font-bold leading-none tracking-wide transition-colors whitespace-nowrap text-secondary-600 group-hover:text-orange-600   xl:px-3 xl:text-sm';

export function publicChromeLocaleButtonClass(active, compact = false) {
  const base = compact ? PUBLIC_CHROME_INNER_BUTTON_COMPACT_CLASS : PUBLIC_CHROME_INNER_BUTTON_CLASS;
  const minWidth = compact ? 'min-w-[2.25rem] xl:min-w-[2.5rem]' : 'min-w-[2.5rem]';

  if (active) {
    return `${minWidth} ${base} bg-gradient-to-r from-orange-500 to-amber-500 text-white shadow-soft group-hover:text-white `;
  }

  return `${minWidth} ${base}`;
}
